export type GreetingSlot = "morning" | "afternoon" | "evening";

/** Time-of-day slot for the dashboard greeting, based on local hour. */
export function getGreetingSlot(date: Date = new Date()): GreetingSlot {
  const hour = date.getHours();
  if (hour < 11) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

/** First token of a display name, for a personal greeting. Empty string if none. */
export function firstName(name?: string | null): string {
  return (name ?? "").trim().split(/\s+/)[0] ?? "";
}
